import openSnackbarReducer from './openSnackbarReducer';
import sesionUsuarioReducer from './sesionUsuarioReducer';
import autorizacionReducer from './autorizacionReducer';
import autorizacionModReducer from './autorizacionModReducer';
import etiquetasIdiomaReducer from './etiquetasIdiomaReducer';
import companyReducer from './companyReducer';
import cargandoReducer from './cargandoReducer';
import autorizacionModExternalReducer from './autorizacionModExternalReducer';

export const mainReducer = ({ sesionUsuario, openSnackbar, autorizacion, autorizacionMod, etiquetasIdioma, compania, cargandoRed, autorizacionModExternal }, action) => {
    return {
        sesionUsuario: sesionUsuarioReducer(sesionUsuario, action),
        openSnackbar: openSnackbarReducer(openSnackbar, action),
        autorizacion: autorizacionReducer(autorizacion, action),
        autorizacionMod: autorizacionModReducer(autorizacionMod, action),
        etiquetasIdioma: etiquetasIdiomaReducer(etiquetasIdioma, action),
        compania: companyReducer(compania, action),
        cargandoRed: cargandoReducer(cargandoRed, action),
        autorizacionModExternal: autorizacionModExternalReducer(autorizacionModExternal, action),
    }
}

